import { getRestAuthHeaders, getRestBaseUrl } from "@api/rest/rest-service";

/**
 * Custom fetcher used by Orval-generated hooks (configured via orval.config.ts).
 *
 * - Prepends the base URL (set via setRestBaseUrl in rest-service.ts) to all relative URLs at runtime.
 * - Awaits getRestAuthHeaders(), which blocks until AppShell has registered the auth getter,
 *   preventing the race condition that caused missing auth headers on page refresh.
 */
export const customFetch = async <T>(url: string, options?: RequestInit): Promise<T> => {
  const authHeaders = await getRestAuthHeaders();

  const mergedHeaders = new Headers(options?.headers);
  authHeaders.forEach((value, key) => mergedHeaders.set(key, value));

  const res = await fetch(`${getRestBaseUrl()}${url}`, { ...options, headers: mergedHeaders });
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  const data = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as T;
};
